import { Orders } from '../../../../../core';

export const reportPickingReadMore = {
  searchText: '',
  addText: '',
  expandable: false,
  filter: false,
  filterDefault: '',
  disabled: false,
  partialField: '',
  showIcon: './assets/icon/ico_placeholder_documentos.svg',
  sort: true,
  columns: [
    {
      title: 'N° Despacho',
      name: 'dispatchNumber',
      type: 'string',
      checkAll: false,
      editable: false,
      class: 'center w130',
      value: (element: Orders) => element.dispatchNumber
    },
    {
      title: 'SKU',
      name: 'sku',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      value: (element: Orders) => element.sku
    },
    {
      title: 'Área',
      name: 'area',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      value: (element: Orders) => element.area
    },
    {
      title: 'Dpto.',
      name: 'department',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      value: (element: Orders) => element.department
    },
    {
      title: 'Marca/Descripción',
      name: 'trademark',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      value: (element: Orders) => element.trademark
    },
    {
      title: 'Cant.',
      name: 'quantity',
      type: 'string',
      editable: false,
      checkAll: false,
      align: 'center',
      value: (element: Orders) => element.quantity
    }
  ]
};
